import { CommonModule } from '@angular/common'
import { Component, EventEmitter, Input, Output } from '@angular/core'
import { SelectOption } from '../../interfaces/select-option.interface'
import { StripHtmlPipe } from '../../pipes/strip-html.pipe'

@Component({
  selector: 'app-check-box-input',
  templateUrl: './check-box-input.component.html',
  styleUrls: ['./check-box-input.component.scss'],
  standalone: true,
  imports: [CommonModule, StripHtmlPipe]
})
export class CheckBoxInputComponent {
  @Input() choices: SelectOption[]
  @Input() selectedChoiceIds: (number | string)[] = []

  @Output() selectedChoiceIdsChanged: EventEmitter<(number | string)[]> =
    new EventEmitter()

  isFilterOptionSelected(filterOptionValue: number | string): boolean {
    return this.selectedChoiceIds.includes(filterOptionValue)
  }

  toggleFilterOption(filterOptionValue: number | string) {
    if (this.isFilterOptionSelected(filterOptionValue)) {
      this.selectedChoiceIds = this.selectedChoiceIds.filter(
        (option) => option !== filterOptionValue
      )
    } else {
      this.selectedChoiceIds.push(filterOptionValue)
    }

    return this.selectedChoiceIdsChanged.emit(this.selectedChoiceIds)
  }
}
